var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMapContext } from "@/domains/map";
import { useI18n } from "@/shared/hooks";
import { useSnackbar } from "@gemini/ui";
export const useBrowserPosition = () => {
    const { setLoadingState } = useMapContext();
    const { add } = useSnackbar();
    const { t } = useI18n();
    // @ts-ignore
    const getUserPosition = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoadingState("fetching_position");
        try {
            const position = yield new Promise((resolve, reject) => {
                // eslint-disable-next-line no-restricted-globals
                navigator.geolocation.getCurrentPosition(resolve, reject);
            });
            setLoadingState("success");
            return {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
            };
        }
        catch (error) {
            setLoadingState("failure");
            add({
                variant: "error",
                description: t("location.map.modal.travel_times.position.snackbar.error"),
            });
        }
    });
    return {
        getUserPosition,
    };
};
